import BaseModule from "$src/js/app/base/BaseModule";
import AddToHomescreenButton from "$src/js/components/organisms/add-to-homescreen/AddToHomescreenButton.svelte";
import AddToHomescreenOverlay from "$src/js/components/organisms/add-to-homescreen/AddToHomescreenOverlay.svelte";
import { mount } from "svelte";

export class AddToHomescreen {
    target: HTMLElement | null = document.querySelector('.js-add-to-homescreen');
    ignoreStorageKey = 'domestique-cycling-addToHomescreenIgnored';
    explainationHashtag = 'addToHomescreenExplanationModal';
    forceHashtag = 'forceAddToHomescreen';

    constructor() {
        if (!this.target) {
            return;
        }

        if (this.validateCompatibleDevice()) {
            this.renderTrigger();
        }

        if (this.validateExplanationModal()) {
            this.renderExplanationModal();
        }
    }

    isChromeOnAndroid() {
        return navigator.userAgent.toLowerCase().includes('android') && navigator.userAgent.toLowerCase().includes('chrome');
    }

    isSafariOnIphone() {
        return navigator.userAgent.toLowerCase().includes('iphone') && navigator.userAgent.toLowerCase().includes('safari');
    }

    isStandalone() {
        return 'standalone' in window.navigator && window.navigator.standalone;
    }

    validateIfHomepage() {
        return window.location.pathname.split('/').length === 3; // Language prefix
    }

    validateCompatibleDevice() {
        const maxScreenWidth = 480;
        const isChromeOnAndroid = this.isChromeOnAndroid();
        const isSafariOnIphone = this.isSafariOnIphone();
        const isForced = location.hash.includes(this.forceHashtag);

        if (window.localStorage.getItem(this.ignoreStorageKey) && !location.hash.includes(this.forceHashtag)) {
            return false;
        }

        if (this.isStandalone()) {
            return false;
        }

        if (isForced) {
            return true;
        }

        return ((isChromeOnAndroid || isSafariOnIphone) && screen.width < maxScreenWidth);
    }

    validateExplanationModal() {
        const isNotStandalone = !this.isStandalone();
        const isHomepage = this.validateIfHomepage();
        const explainationRequested = location.hash.includes(this.explainationHashtag);

        return isHomepage && explainationRequested && isNotStandalone;
    }

    hideTrigger() {
        if (!this.target) {
            return;
        }

        this.target.remove();
        window.localStorage.setItem(this.ignoreStorageKey, 'true');
    }

    renderTrigger() {
        if (!this.target) {
            return;
        }

        mount(AddToHomescreenButton, {
            target: this.target,
            props: {
                href: `${BaseModule.getInstance().routing.setlanguagePathPrefix('/')}#${this.explainationHashtag}`,
                onClose: () => this.hideTrigger(),
                openExplanationModal: () => {
                    this.hideTrigger();

                    if (this.validateIfHomepage()) {
                        this.renderExplanationModal()
                    }
                }
            }
        });
    }

    renderExplanationModal() {
        // Only show when user is on Android Chrome or iOS Safari
        if (!this.isChromeOnAndroid() && !this.isSafariOnIphone()) {
            return;
        }

        mount(AddToHomescreenOverlay, {
            target: document.body,
            props: {
                isAndroid: this.isChromeOnAndroid(),
                isIphone: this.isSafariOnIphone(),
            }
        });
    }
};